export const workflowConstants = {
  WORKFLOW_REQUEST: 'WORKFLOW_REQUEST',
  WORKFLOW_SUCCESS: 'WORKFLOW_SUCCESS',
  WORKFLOW_FAILURE: 'WORKFLOW_FAILURE',

  WORKFLOW_RES_REQUEST: 'WORKFLOW_RES_REQUEST',
  WORKFLOW_RES_SUCCESS: 'WORKFLOW_RES_SUCCESS',
  WORKFLOW_RES_FAILURE: 'WORKFLOW_RES_FAILURE',

  CONTINUE_WORKFLOW_REQUEST: 'CONTINUE_WORKFLOW_REQUEST',
  CONTINUE_WORKFLOW_SUCCESS: 'CONTINUE_WORKFLOW_SUCCESS',
  CONTINUE_WORKFLOW_FAILURE: 'CONTINUE_WORKFLOW_FAILURE',
  CONTINUE_WORKFLOW_RESET: 'CONTINUE_WORKFLOW_RESET',

  CANCEL_WORKFLOW_REQUEST: 'CANCEL_WORKFLOW_REQUEST',
  CANCEL_WORKFLOW_SUCCESS: 'CANCEL_WORKFLOW_SUCCESS',
  CANCEL_WORKFLOW_FAILURE: 'CANCEL_WORKFLOW_FAILURE',

  WORKFLOW_DEFINICION_REQUEST: 'WORKFLOW_DEFINICION_REQUEST',
  WORKFLOW_DEFINICION_SUCCESS: 'WORKFLOW_DEFINICION_SUCCESS',
  WORKFLOW_DEFINICION_FAILURE: 'WORKFLOW_DEFINICION_FAILURE',

  GET_BINNACLE_REQUEST: 'GET_BINNACLE_REQUEST',
  GET_BINNACLE_SUCCESS: 'GET_BINNACLE_SUCCESS',
  GET_BINNACLE_FAILURE: 'GET_BINNACLE_FAILURE',

  REG_STATUSSTAGE_REQUEST: 'REG_STATUSSTAGE_REQUEST',
  REG_STATUSSTAGE_SUCCESS: 'REG_STATUSSTAGE_SUCCESS',
  REG_STATUSSTAGE_FAILURE: 'REG_STATUSSTAGE_FAILURE',
}
